// src/app/utils/lottie-player-factory.ts

import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import type { AnimationItem } from 'lottie-web'; // Optional, if you want typing

export function lottiePlayerFactory() {
  const platformId = inject(PLATFORM_ID);

  if (isPlatformBrowser(platformId)) {
    return import('lottie-web'); // ⬅️ Only dynamically import on browser
  } else {
    return Promise.resolve(null as any); // ⬅️ Return null on server to avoid crash
  }
}
